import styled from 'styled-components';

const Container = styled.div`
  max-width: 1295px;
  margin: 0 auto;
`;

export default Container;
